module.exports = __webpack_public_path__ + "media/images/admin/icons/square-8c2fd5ee4efa3610011214c0ea27b3ee.svg";